module.exports = __webpack_public_path__ + "static/media/company-logo-removebg.93043f5f.png";